import { Null, Number, Record, String } from 'runtypes';

export let FileDescRuntype = Record({
  id: String,
  name: String,
  size: Number,
  type: String,
  imageType: String.Or(Null).optional(),
  width: Number.Or(Null).optional(),
  height: Number.Or(Null).optional(),
  preview: String.optional(),
  expiryValue: String.optional(),
});
